import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { brand } from '../theme.js';

/**
 * Marca do NaPorta.club.
 *
 * O símbolo é um SVG inline: evita uma requisição extra no primeiro
 * carregamento e acompanha a cor do tema sem precisar de variantes de arquivo.
 * O desenho remete a uma porta com um selo, ligando "entrega na porta" à ideia
 * de clube.
 */
export default function Logo({ size = 34, showText = true }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25 }}>
      <Box
        component="svg"
        viewBox="0 0 40 40"
        role="img"
        aria-label="NaPorta.club"
        sx={{ width: size, height: size, flexShrink: 0 }}
      >
        <rect x="1.5" y="1.5" width="37" height="37" rx="11" fill={brand.purple500} />
        <rect x="11" y="9" width="14" height="22" rx="2.5" fill="#FFFFFF" opacity="0.95" />
        <circle cx="21.6" cy="20" r="1.5" fill={brand.purple700} />
        <path
          d="M27 24.5c3.2 0 5.8-2.6 5.8-5.8S30.2 12.9 27 12.9"
          stroke={brand.gold}
          strokeWidth="2.6"
          strokeLinecap="round"
          fill="none"
        />
      </Box>
      {showText && (
        <Typography variant="h6" component="span" sx={{ fontWeight: 800, letterSpacing: '-0.02em' }}>
          NaPorta
          <Box component="span" sx={{ color: 'secondary.main' }}>
            .club
          </Box>
        </Typography>
      )}
    </Box>
  );
}
